// extracted by mini-css-extract-plugin
var _1 = "OnboardingV2-module__backgroundImage--B91mK";
var _2 = "#aae0fa";
var _3 = "#d4effc";
var _4 = "OnboardingV2-module__scene--ehaA7";
var _5 = "OnboardingV2-module__sceneLoadingContainer--V_0M5";
var _6 = "OnboardingV2-module__sceneLoadingSizing--Cyc4H";
export { _1 as "backgroundImage", _2 as "colorBgSkyBlue", _3 as "colorBgSkyBlueLoading", _4 as "scene", _5 as "sceneLoadingContainer", _6 as "sceneLoadingSizing" }
